function numM(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export const TIPOS_MEMORIA = [
    { valor: "hecho",       label: "Hecho",       color: "#3b82f6" },
    { valor: "preferencia", label: "Preferencia", color: "#8b5cf6" },
    { valor: "aprendizaje", label: "Aprendizaje", color: "#10b981" },
    { valor: "negocio",     label: "Negocio",     color: "#f59e0b" },
    { valor: "usuario",     label: "Usuario",     color: "#ec4899" },
];

export class ChatMemoriaDto {
    public id: number = 0;
    public idCliente: number = 0;
    public tipo: string = "hecho";
    public clave: string = "";
    public valor: string = "";
    public contexto: string = "";
    public relevancia: number = 5;
    public vecesUsado: number = 0;
    public activo: boolean = true;
    public datecreated: string = "";

    constructor(data?: any) {
        if (!data) { return; }
        this.id          = numM(data.Id,         data.id);
        this.idCliente   = numM(data.Id_cliente,  data.id_cliente);
        this.tipo        = data.Tipo        || data.tipo        || "hecho";
        this.clave       = data.Clave       || data.clave       || "";
        this.valor       = data.Valor       || data.valor       || "";
        this.contexto    = data.Contexto    || data.contexto    || "";
        this.relevancia  = numM(data.Relevancia,  data.relevancia) || 5;
        this.vecesUsado  = numM(data.Veces_usado, data.veces_usado);
        this.activo      = data.Activo !== undefined ? data.Activo : (data.activo !== undefined ? data.activo : true);
        this.datecreated = data.Datecreated || data.datecreated || "";
    }

    public toJson(): object {
        return {
            id:          this.id,
            id_cliente:  this.idCliente,
            tipo:        this.tipo,
            clave:       this.clave,
            valor:       this.valor,
            contexto:    this.contexto,
            relevancia:  this.relevancia,
            veces_usado: this.vecesUsado,
            activo:      this.activo
        };
    }

    public get tipoColor(): string {
        const t = TIPOS_MEMORIA.find((x) => x.valor === this.tipo);
        return t ? t.color : "#6b7280";
    }

    public get tipoLabel(): string {
        const t = TIPOS_MEMORIA.find((x) => x.valor === this.tipo);
        return t ? t.label : this.tipo;
    }
}
